import styled, { css } from 'styled-components';
import { hover } from 'src/components/utils';

export const Button = styled.button(
  ({ theme }) => css`
    display: flex;
    padding: ${theme.sz.s1};
    font-size: ${theme.sz.s8};
    background: none;
    border: none;
    border-radius: ${theme.bo.round};
    cursor: pointer;

    &:hover,
    &:active {
      background-color: ${hover(theme.co.neutral98)};
      color: ${theme.co.secondary0};
    }
  `,
);
